import RequestQuoteFormState from "@iewcasia/Store/State/RfqRequestQuote/RequestQuoteFormState";
import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { Draft } from "immer";

const initialState: RequestQuoteFormState = {
    fieldValues: {},
};

const reducer = {
    "Components/RequestQuoteFormStateForm/ClearForm": (draft: Draft<RequestQuoteFormState>) => {
        draft.fieldValues = {};
        draft.file = undefined;
    },
    "Components/RequestQuoteFormStateForm/SetFieldValue": (
        draft: Draft<RequestQuoteFormState>,
        action: { key: string; value: string },
    ) => {
        draft.fieldValues[action.key] = action.value;
    },
    "Components/RequestQuoteFormStateForm/SetFileValue": (
        draft: Draft<RequestQuoteFormState>,
        action: File | string,
    ) => {
        const value = (action as any).value;
        if (!value || value === "") {
            draft.file = undefined;
        } else {
            draft.file = action as File;
        }
    },
};

export default createTypedReducerWithImmer(initialState, reducer);
